import angular from 'angular';
 import { ErrorInterceptor } from '@adjust/dashboard-core/app/error-page/error-interceptor.service';
 import config from './error-page.routes';

 export default angular.module('adjust.error-page', [])
   .config(config)
   .factory('ErrorInterceptor', ErrorInterceptor)
   .name;
